/**
 * useHomepageModules
 */

import {
    Queries,
    ApolloLib,
} from 'bdvp-graphql';

const {
    useQuery,
} = ApolloLib;
const {
    GET_HOMEPAGE_MODULES,
} = Queries;

const useHomepageModules = ({
    ssr = true,
    dir = 'homepage',
    lang = 'en',
    skip = false,
}) => {

    const {
        loading,
        error,
        data,
    } = useQuery(
        GET_HOMEPAGE_MODULES,
        {
            variables: {
                dir,
                lang,
            },
            ssr,
            skip,
        }
    );

    return {
        loading,
        data,
        error,
    };

};

export default useHomepageModules;
